import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Legacy ESS Reports route — Payslips & Form-16 now live under Payroll.
 * Keep this redirect so old bookmarks /nav still work.
 */
const EmployeeReports = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/employee/payroll?tab=payslips", { replace: true });
  }, [navigate]);

  return (
    <div className="flex min-h-[40vh] items-center justify-center p-6 text-sm text-slate-600">
      Redirecting to Payroll → Payslips…
    </div>
  );
};

export default EmployeeReports;
